import React from 'react';
import { TrustyProvider } from '../features/Trusty_game/components/TrustyProvider';
import { TrustyGame } from '../features/Trusty_game/components/TrustyGame';

const TrustyGamePage = () => {
    return (
        <TrustyProvider>
            <TrustyGame />
        </TrustyProvider>
    );
};

export { TrustyGamePage };
